if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.featured = this.dataset.featured;
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (!this.featured) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const productSlider = document.getElementById(`MediaGallery-${this.dataset.section}`);
      if (!productSlider) return;
      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = productSlider.querySelector(`[data-media-id="${ mediaId }"]`);

      productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      // With "Hide unselected variants' media" the variant slides are hidden, so keep
      // the selected one in the thumbnail rail — otherwise there is no way back to the
      // packshot once a lifestyle image is opened.
      productSlider.querySelectorAll('.product-images__slide-item--variant').forEach((element) => {
        element.classList.remove('is-variant-active');
      });
      const variantThumb = productSlider.querySelector(`.product-thumbnail[data-media-id="${mediaId}"]`);
      if (variantThumb) variantThumb.classList.add('is-variant-active');

      if (this.featured) return;

      // Desktop big-image galleries (everything except the redesign carousel) keep the
      // slide order fixed: CSS makes :first-child the big image, so moving a thumbnail
      // to the front would promote it and demote the real big slide to the rail — the
      // thumbnail click handlers, which hold a reference to the original first slide,
      // would then write into a 136px cell and the gallery would stop responding.
      // Instead reuse the thumbnail click, which swaps the big image's content in place.
      const isBigImageDesktop =
        !document.querySelector('[data-cc-gallery]') &&
        productSlider.querySelector('.product-images--big-image') &&
        window.matchMedia('(min-width: 1068px)').matches;

      if (isBigImageDesktop) {
        const thumb = productSlider.querySelector(`.product-thumbnail[data-media-id="${mediaId}"]`);
        if (thumb) thumb.click();
        return;
      }

      activeMedia.parentElement.prepend(activeMedia);

      window.setTimeout(() => {
        activeMedia.parentElement.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth'
        });
      });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButtonText.textContent = window.theme.variantStrings.addToCart;
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index+1}`
          };
        });
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      const _this = this;
      const product_container = this.closest('.thb-product-detail');

      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

      // Start Gallery
      this.addEventListener('change', this.setupProductGallery);
      this.setupProductGallery();

      // Start Pagination

      if (this.pagination) {
        this.setupPagination();
        this.addEventListener('scroll', this.updatePagination.bind(this));
        const resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        resizeObserver.observe(this);
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      let activeImages = Array.from(this.querySelectorAll('.product-single__media-image'));

      this.setEventListeners(this, activeImages);
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        if(!activelink) return 
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners(container, activeImages) {
      const storeName = document.querySelector('[store-name]')?.getAttribute('store-name');

      let links = storeName === 'rslt' ? container.querySelectorAll('.product-single-image') : container.querySelectorAll('.product-single__media-zoom'),
        items = container.buildItems(activeImages),
        captionEl = container.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };


      const productSlider = document.querySelector('#Product-Slider');

      if (storeName === 'rslt' && productSlider?.classList.contains('product-images--big-image')) {
        this.rsltBigImageGallery(links, options, pswpElement, items);
      } else {
        this.defaultImageGallery(links, options, pswpElement, items);
      }
    }

     rsltBigImageGallery(links,  options, pswpElement, items) {
      console.log("RSLT Big Image Gallery");
      links.forEach((link) => {
        link.addEventListener('click', (event) => {
            const activeSlide = document.querySelector('.product-images__slide.is-active-slide');
            let activeSlideIndex;
            if (!activeSlide){
              activeSlideIndex = 0;
            }
            else {
              activeSlideIndex = activeSlide?.dataset.index;
            }

            const index = activeSlideIndex ? parseInt(activeSlide.dataset.index, 10) : 0;
            
            options.index = index;
            options.getThumbBoundsFn = () => {
              const thumbnail = link.closest('.product-single__media');
              const rect = thumbnail.getBoundingClientRect();
              const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          
              return { 
                  x: rect.left, 
                  y: rect.top + pageYScroll, 
                  w: rect.width 
              };
          };
    
            if (typeof PhotoSwipe !== 'undefined') {
                let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
                pswp.listen('firstUpdate', () => {
                    pswp.listen('parseVerticalMargin', (item) => {
                        item.vGap = { 
                          top: 50, 
                          bottom: 50 
                        };
                    });
                });
                pswp.init();
            }
            event.preventDefault();
        });
      });
    }

     defaultImageGallery(links,  options, pswpElement, items) {
      console.log("Default Image Gallery");
      links.forEach((link => {
        link.addEventListener('click', (event) => {
          let i = link.dataset.index;
          options.index = parseInt(i, 10);
          options.getThumbBoundsFn = () => {
            const thumbnail = link.closest('.product-single__media'),
              pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect();
            return {
              x: rect.left,
              y: rect.top + pageYScroll,
              w: rect.width
            };
          };
          if (typeof PhotoSwipe !== 'undefined') {
            let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            pswp.listen('firstUpdate', function() {
              pswp.listen('parseVerticalMargin', function(item) {
                item.vGap = {
                  top: 50,
                  bottom: 50
                };
              });
            });
            pswp.init();
          }
          event.preventDefault();
        });
      }));
    }

    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

if (!customElements.get('product-form')) {
  /**
   *  @class
   *  @function ProductForm
   */
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.sticky = this.dataset.sticky;
        this.form = document.getElementById(`product-form-${this.dataset.section}`);
        this.form.querySelector('[name=id]').disabled = false;
        if (!this.sticky) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        this.cartNotification = document.querySelector('cart-notification');
        this.body = document.body;

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        if(evt) evt.preventDefault();
        
        if (!this.form.reportValidity()) {
          return;
        }
        const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains('loading')) return;
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        });

        this.handleErrorMessage();

        let formData = new FormData(this.form);

        let productVariantId = formData.get('id');
        let hasFreeGift = false;

        if(productVariantId) {
          productVariantId = parseInt(productVariantId);
          const getCart = await Shopify.functions.getCart();
  
          if(getCart.items) {
            const freeGiftProducts = window.theme.settings.free_gift_products;
  
            let isFreeGiftProduct = freeGiftProducts.some(product => 
              product.variants && product.variants.some(variant => variant.id === productVariantId)
            );
  
            if (isFreeGiftProduct) {
              const freeGifts = getCart.items.filter(item =>
                item.discounts.some(discount =>
                  discount.title === window.theme.settings.free_gift && discount.amount > 0
                )
              );
  
              hasFreeGift = freeGifts.length > 0;
              if(hasFreeGift) {
                submitButtons.forEach((submitButton) => {
                  submitButton.classList.remove('loading');
                  submitButton.removeAttribute('aria-disabled');
                });
                return;
              };
            }
          }
        }

        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          }
        };

        formData.append('sections', this.getSectionsToRender().map((section) => section.section));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              dispatchCustomEvent('product:variant-error', {
                source: 'product-form',
                productVariantId: productVariantId,
                errors: response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description);
              return;
            }

            this.renderContents(response);

            dispatchCustomEvent('cart:item-added', {
              product: response.hasOwnProperty('items') ? response.items[0] : response
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            });
          });
      }

      getSectionsToRender() {
        return [{
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }];
      }
      renderContents(parsedState) {
        let isCartDrawerInitialized = false;
        this.getSectionsToRender().forEach((section => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

          if (typeof CartDrawer !== 'undefined') {
            if (!isCartDrawerInitialized) {
              new CartDrawer();
              isCartDrawerInitialized = true;
            }
          }
          if (typeof Cart !== 'undefined') {
            new Cart().renderContents(parsedState);
          }
        }));



        let product_drawer = document.getElementById('Product-Drawer');
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
          document.body.classList.remove('open-quick-view');

          if (window.innerWidth < 1069) {
            product_drawer.classList.remove('active');
            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')?.classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          } else {
            product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function() {
              product_drawer.classList.remove('active');

              if (document.getElementById('Cart-Drawer')) {
                document.getElementById('Cart-Drawer').classList.add('active');
                document.body.classList.add('open-cart');
                document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')?.classList.add('active');
                dispatchCustomEvent('cart-drawer:open');
              }
            });
          }

          if (!document.getElementById('Cart-Drawer')) {
            document.body.classList.remove('open-cc');
          }
        } else if (document.getElementById('Cart-Drawer')) {
          document.body.classList.add('open-cc');
          document.body.classList.add('open-cart');
          document.getElementById('Cart-Drawer').classList.add('active');
          dispatchCustomEvent('cart-drawer:open');
        }
      }
      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    };
    customElements.define('product-form', ProductForm);

  /**
   *  @class
   *  @function FreeGiftForm
   */
  if (!customElements.get('free-gift-form')) {

    class FreeGiftForm extends ProductForm {
      constructor() {
        super();
        if(!this.form) return;
        this.productSelected = this.form.querySelector('[name=id]').value;

        this.idInput = this.form.querySelector('input[name=id]');
        this.productIdInput = this.form.querySelector('input[name=product-id]');
        this.fieldset = this.form.querySelector('fieldset.product-cart-free-gifts');

        this.fieldset.addEventListener('change', this.onVariantSelect.bind(this));
      }

      onVariantSelect(e) {
        e.preventDefault();
        this.productSelected = e.target.value;
        this.productId = e.target.dataset.productId;
        if(this.productSelected && this.productSelected != '') {
          this.idInput.value = this.productSelected;
          if(this.productIdInput && this.productId) this.productIdInput.value = this.productId;
          this.fieldset.classList.add('free-gift-selected');
        } else {
          this.idInput.value = '';
          if(this.productIdInput && this.productId) this.productIdInput.value = '';
          this.fieldset.classList.remove('free-gift-selected');
        }

        this.onSubmitHandler();
      }
    }

    customElements.define('free-gift-form', FreeGiftForm);
  }
  }

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.addToCartVisible = true;
      this.animationInProgress = false;
      this.isSmallScreen = false;
      this.scrollingUp = false;
      this.lastScrollY = window.scrollY;
      this.addToCartAboveViewport = false;
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      // Set up toggle functionality
      this.setupToggle();

      // Find necessary elements
      this.addToCartButton = document.getElementById('AddToCart');

      // Check initial screen size
      this.checkScreenSize();

      // Add resize listener to update when screen size changes
      window.addEventListener('resize', this.handleResize.bind(this));

      // If AddToCart button exists, add observer for it
      if (this.addToCartButton) {
        this.setupAddToCartObserver();
      } else {
        // If no AddToCart button, only show sticky on small screens
        this.addToCartVisible = false;
        this.updateVisibility();
      }

      // Track scroll direction
      this.boundHandleScroll = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.boundHandleScroll, { passive: true });
    }

    handleScroll() {
      const currentScrollY = window.scrollY;
      const wasScrollingUp = this.scrollingUp;
      this.scrollingUp = currentScrollY < this.lastScrollY;
      this.lastScrollY = currentScrollY;

      if (wasScrollingUp !== this.scrollingUp) {
        this.updateVisibility();
      }
    }

    handleResize() {
      const wasSmallScreen = this.isSmallScreen;
      this.checkScreenSize();

      // If screen size category changed, update visibility
      if (wasSmallScreen !== this.isSmallScreen) {
        this.updateVisibility();
      }
    }

    checkScreenSize() {
      this.isSmallScreen = window.innerWidth <= 1067;
    }

    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner');
      const content = this.querySelector('.product-add-to-cart-sticky--content');

      if (!button || !content) return;

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();
          return false;
        });

        this.toggleTimeline = tl;
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }
    }

    setupAddToCartObserver() {
      const addToCartObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const wasVisible = this.addToCartVisible;
        this.addToCartVisible = entry.isIntersecting;
        // True only when button has been scrolled above the viewport (user is below it)
        this.addToCartAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;

        if (wasVisible !== this.addToCartVisible) {
          this.updateVisibility();
        }
      }, {
        threshold: [0],
        rootMargin: '0px'
      });

      addToCartObserver.observe(this.addToCartButton);
    }

    updateVisibility() {
      // Show sticky element only when:
      // 1. AddToCart button is not visible AND has been scrolled above viewport AND
      // 2. Screen width is 1067px or less AND
      // 3. User is scrolling up
      const shouldBeVisible = !this.addToCartVisible && this.addToCartAboveViewport && this.isSmallScreen && this.scrollingUp;

      if (shouldBeVisible && !this.classList.contains('sticky--visible')) {
        this.showWithAnimation();
      } else if (!shouldBeVisible && this.classList.contains('sticky--visible')) {
        this.hideWithAnimation();
      }
    }

    showWithAnimation() {
      if (this.animationInProgress) return;

      this.animationInProgress = true;
      this.classList.add('sticky--visible');

      if (this.animations_enabled && typeof gsap !== 'undefined') {
        gsap.set(this, {
          clearProps: 'all'
        });

        gsap.fromTo(this, {
          opacity: 0,
          y: '100%'
        }, {
          opacity: 1,
          y: '0%',
          duration: 0.3,
          ease: 'power2.out',
          onComplete: () => {
            this.animationInProgress = false;
          }
        });
      } else {
        this.animationInProgress = false;
      }
    }

    hideWithAnimation() {
      if (this.animationInProgress) return;

      this.animationInProgress = true;

      if (this.animations_enabled && typeof gsap !== 'undefined') {
        gsap.to(this, {
          opacity: 0,
          y: '100%',
          duration: 0.3,
          ease: 'power2.in',
          onComplete: () => {
            this.classList.remove('sticky--visible');
            this.animationInProgress = false;
          }
        });
      } else {
        this.classList.remove('sticky--visible');
        this.animationInProgress = false;
      }
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      window.removeEventListener('resize', this.handleResize.bind(this));
      window.removeEventListener('scroll', this.boundHandleScroll);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

document.addEventListener('DOMContentLoaded', () => {
  const productSlider = document.querySelector('.product-images--big-image');
  if (!productSlider) return;

  // Only the redesign gallery uses Flickity (marked by data-cc-gallery). Flickity is a
  // global vendor lib (vendor.min.js), so checking `typeof Flickity` would wrongly skip
  // the legacy swap on standard templates and kill their thumbnails.
  if (document.querySelector('[data-cc-gallery]')) return;

  const slides = productSlider.querySelectorAll('.product-images__slide');
  if (slides.length < 2) return;

  // slides[0] = big image (CSS grid col 2), slides[1+] = thumbnails (col 1)
  const bigSlide = slides[0];
  const featuredMediaId = bigSlide.dataset.mediaId;

  // Save the original media element to restore later
  const originalMedia = bigSlide.querySelector('.product-single__media');
  const originalMediaClone = originalMedia ? originalMedia.cloneNode(true) : null;

  // Click on any thumbnail → swap big image content
  for (let i = 1; i < slides.length; i++) {
    const thumbSlide = slides[i];

    thumbSlide.addEventListener('click', (e) => {
      // Big-image swap only applies on desktop. On mobile the featured slide
      // is display:none, so swapping would play video inside a hidden element
      // and steal the tap from the visible slide's native video controls.
      if (!window.matchMedia('(min-width: 1068px)').matches) return;

      // Update active states
      slides.forEach((s) => s.classList.remove('is-active-slide'));
      thumbSlide.classList.add('is-active-slide');

      const isFeatured = thumbSlide.dataset.mediaId === featuredMediaId;
      const currentMedia = bigSlide.querySelector('.product-single__media');

      // Stop any playing video in big area
      const currentVideo = currentMedia ? currentMedia.querySelector('video') : null;
      if (currentVideo) currentVideo.pause();

      if (isFeatured) {
        // Restore original featured image with badges
        if (currentMedia && originalMediaClone) {
          currentMedia.replaceWith(originalMediaClone.cloneNode(true));
        }
      } else {
        // Replace entire media container with cloned thumbnail media
        const thumbMedia = thumbSlide.querySelector('.product-single__media');
        if (thumbMedia && currentMedia) {
          const cloned = thumbMedia.cloneNode(true);
          cloned.style.pointerEvents = 'auto';

          const clonedVideo = cloned.querySelector('video');
          if (clonedVideo) {
            clonedVideo.controls = true;
            clonedVideo.style.pointerEvents = 'auto';
            clonedVideo.style.width = '100%';
            clonedVideo.style.height = '100%';
            clonedVideo.style.objectFit = 'contain';
          }

          // Hide badges on non-featured media
          const badge = cloned.querySelector('.product-badge-container');
          if (badge) badge.style.display = 'none';

          currentMedia.replaceWith(cloned);

          if (clonedVideo) clonedVideo.play();
        }
      }

      // Handle badges on restored original
      const badgeContainer = bigSlide.querySelector('.product-badge-container');
      if (badgeContainer) {
        badgeContainer.style.display = isFeatured ? 'flex' : 'none';
      }
    });
  }

  // Initial badge state
  const badgeContainer = bigSlide.querySelector('.product-badge-container');
  if (badgeContainer) {
    badgeContainer.style.display = 'flex';
  }
});

// Gallery: Flickity carousel (swipe on desktop + mobile) + desktop thumbnail strip
document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('#Product-Slider');
  if (!slider || typeof Flickity === 'undefined') return;
  // Flickity is a global vendor lib, so gate the carousel on the redesign marker
  // (data-cc-gallery). Without this it hijacks standard big-image galleries — which have
  // no thumbnail-nav — and their thumbnails disappear.
  if (!document.querySelector('[data-cc-gallery]')) return;
  // Only the big-image layout uses the Flickity carousel. Other layouts (collage,
  // grid) keep their own markup — initialising Flickity there double-renders.
  if (!slider.classList.contains('product-images--big-image')) return;
  // product.js loads twice (theme head + product section) — init Flickity once
  if (slider.classList.contains('flickity-enabled')) return;

  // Exclude hidden variant media so Flickity does not create blank cells
  const cellSelector = '.product-thumbnail:not(.product-images__slide-item--variant)';
  const cells = Array.from(slider.querySelectorAll(cellSelector));
  if (cells.length < 1) {
    // No carousel will be built, so drop the marker that shrinks the featured
    // slide to cell width — otherwise it stays narrow forever.
    slider.classList.remove('product-images--carousel');
    return;
  }

  // Start on the featured media so its badges show first
  const featuredSlide = slider.querySelector('.product-images__slide--featured');
  const featuredMediaId = featuredSlide ? featuredSlide.dataset.mediaId : null;
  const initialIndex = Math.max(0, cells.findIndex((c) => c.dataset.mediaId === featuredMediaId));

  const flkty = new Flickity(slider, {
    cellSelector: cellSelector,
    initialIndex: initialIndex,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: false,
    contain: true,
    // Left align so the mobile peek (cell < 100vw) reveals the NEXT slide on the right
    cellAlign: 'left',
    // adaptiveHeight off: all cells are equal-width squares, so a fixed viewport
    // height is stable. adaptiveHeight mis-measured per-slide heights (short
    // viewport while the cell image stayed full size behind it).
    adaptiveHeight: false,
    draggable: true,
  });

  // Desktop: force every cell to the carousel width so Flickity lays them out as
  // full-width slides. Parcel's `.product-images--big-image` grid + aspect-ratio
  // sizing otherwise leaves non-initial cells collapsed (~130px), so switching
  // slide reveals all cells at once. Explicit px width (not %) avoids the
  // cell-width-vs-slider-width circular dependency. Mobile keeps the CSS peek.
  const desktopMq = window.matchMedia('(min-width: 1068px)');
  const sizeFlickityCells = () => {
    if (desktopMq.matches) {
      const w = slider.clientWidth;
      if (w > 0) cells.forEach((c) => { c.style.width = w + 'px'; });
    } else {
      cells.forEach((c) => { c.style.width = ''; });
    }
    flkty.resize();
  };
  // Enable the height transition only once the init-time sizing passes are done.
  const markGalleryReady = () => slider.classList.add('is-gallery-ready');
  sizeFlickityCells();
  requestAnimationFrame(sizeFlickityCells);
  if (document.readyState !== 'complete') {
    window.addEventListener('load', () => {
      sizeFlickityCells();
      markGalleryReady();
    }, { once: true });
  } else {
    requestAnimationFrame(markGalleryReady);
  }
  window.addEventListener('resize', sizeFlickityCells);

  // Desktop thumbnail strip <-> carousel sync
  const nav = document.querySelector('.product-thumbnails-nav');
  if (!nav) return;

  const items = Array.from(nav.querySelectorAll('.product-thumbnails-nav__item'));
  const setActive = (index) => {
    items.forEach((it) => it.classList.toggle('is-active', Number(it.dataset.targetIndex) === index));
  };

  items.forEach((item) => {
    item.addEventListener('click', () => flkty.select(Number(item.dataset.targetIndex)));
  });
  flkty.on('change', (index) => setActive(index));
  setActive(flkty.selectedIndex);
});